/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WarehouseAddReqVo
 */
export interface WarehouseAddReqVo {
    /**
     * 仓库类型 1=自营 2=代理
     * @type {number}
     * @memberof WarehouseAddReqVo
     */
    warehouseType: number;
    /**
     * 仓库名称（韩文）
     * @type {string}
     * @memberof WarehouseAddReqVo
     */
    name: string;
    /**
     * 仓库中文名称
     * @type {string}
     * @memberof WarehouseAddReqVo
     */
    nameCn?: string;
    /**
     * 国家ID
     * @type {number}
     * @memberof WarehouseAddReqVo
     */
    nationId: number;
    /**
     * 仓库编码
     * @type {string}
     * @memberof WarehouseAddReqVo
     */
    code: string;
    /**
     * 代理编号（代理仓库填写）
     * @type {string}
     * @memberof WarehouseAddReqVo
     */
    warehouseProxyCode?: string;
    /**
     * 纸箱唛头号前缀
     * @type {string}
     * @memberof WarehouseAddReqVo
     */
    boxMarknoPrefix?: string;
    /**
     * 托盘唛头号前缀
     * @type {string}
     * @memberof WarehouseAddReqVo
     */
    palletMarknoPrefix?: string;
    /**
     * 邮政编码
     * @type {string}
     * @memberof WarehouseAddReqVo
     */
    zip?: string;
    /**
     * 关联海外仓ID（代理仓库填写）
     * @type {number}
     * @memberof WarehouseAddReqVo
     */
    connectWarehouseId?: number;
    /**
     * 城市
     * @type {string}
     * @memberof WarehouseAddReqVo
     */
    city?: string;
    /**
     * 省/州
     * @type {string}
     * @memberof WarehouseAddReqVo
     */
    state?: string;
    /**
     * 地址
     * @type {string}
     * @memberof WarehouseAddReqVo
     */
    address?: string;
    /**
     * 详细地址
     * @type {string}
     * @memberof WarehouseAddReqVo
     */
    addressDetail?: string;
    /**
     * 地址（英文）
     * @type {string}
     * @memberof WarehouseAddReqVo
     */
    addressEn?: string;
    /**
     * 详细地址（英文）
     * @type {string}
     * @memberof WarehouseAddReqVo
     */
    addressDetailEn?: string;
    /**
     * 联系方式
     * @type {string}
     * @memberof WarehouseAddReqVo
     */
    mobileNo?: string;
    /**
     * 联系人姓名
     * @type {string}
     * @memberof WarehouseAddReqVo
     */
    contactName?: string;
    /**
     * 状态 0=禁用 1=启用，默认启用
     * @type {number}
     * @memberof WarehouseAddReqVo
     */
    enable?: number;
    /**
     * 入库方式 1=快递 2=唛头 3=入库证（多选）
     * @type {Array<number>}
     * @memberof WarehouseAddReqVo
     */
    receivingMethod?: Array<number>;
    /**
     * COUPANG中转 0=否 1=是
     * @type {number}
     * @memberof WarehouseAddReqVo
     */
    transshipment?: number;
    /**
     * 3PL功能 1=仓储 2=一件代发（多选）
     * @type {Array<number>}
     * @memberof WarehouseAddReqVo
     */
    warehouseFunction?: Array<number>;
    /**
     * 一件代发预支费用（韩币）
     * @type {number}
     * @memberof WarehouseAddReqVo
     */
    dropshippingFee?: number;
    /**
     * 免仓储费时限（天）
     * @type {number}
     * @memberof WarehouseAddReqVo
     */
    freeStorageDays?: number;
    /**
     * 橙火订单免仓储费时限（天）
     * @type {number}
     * @memberof WarehouseAddReqVo
     */
    rocketOrderFreeStorageDays?: number;
    /**
     * 仓储费单价（1CBM/1Day，韩币）
     * @type {number}
     * @memberof WarehouseAddReqVo
     */
    storageFeeUnit?: number;
    /**
     * 纸箱卸货费单价（韩币）
     * @type {number}
     * @memberof WarehouseAddReqVo
     */
    boxUnloadingFeeUnit?: number;
    /**
     * 托盘卸货费单价（韩币）
     * @type {number}
     * @memberof WarehouseAddReqVo
     */
    palletUnloadingFeeUnit?: number;
    /**
     * 支持的运输方式ID列表
     * @type {Array<number>}
     * @memberof WarehouseAddReqVo
     */
    transportMethodIds?: Array<number>;
}

/**
 * Check if a given object implements the WarehouseAddReqVo interface.
 */
export function instanceOfWarehouseAddReqVo(value: object): value is WarehouseAddReqVo {
    if (!('warehouseType' in value) || value['warehouseType'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('nationId' in value) || value['nationId'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function WarehouseAddReqVoFromJSON(json: any): WarehouseAddReqVo {
    return WarehouseAddReqVoFromJSONTyped(json, false);
}

export function WarehouseAddReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WarehouseAddReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'warehouseType': json['warehouseType'],
        'name': json['name'],
        'nameCn': json['nameCn'] == null ? undefined : json['nameCn'],
        'nationId': json['nationId'],
        'code': json['code'],
        'warehouseProxyCode': json['warehouseProxyCode'] == null ? undefined : json['warehouseProxyCode'],
        'boxMarknoPrefix': json['boxMarknoPrefix'] == null ? undefined : json['boxMarknoPrefix'],
        'palletMarknoPrefix': json['palletMarknoPrefix'] == null ? undefined : json['palletMarknoPrefix'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'connectWarehouseId': json['connectWarehouseId'] == null ? undefined : json['connectWarehouseId'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'address': json['address'] == null ? undefined : json['address'],
        'addressDetail': json['addressDetail'] == null ? undefined : json['addressDetail'],
        'addressEn': json['addressEn'] == null ? undefined : json['addressEn'],
        'addressDetailEn': json['addressDetailEn'] == null ? undefined : json['addressDetailEn'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'contactName': json['contactName'] == null ? undefined : json['contactName'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'receivingMethod': json['receivingMethod'] == null ? undefined : json['receivingMethod'],
        'transshipment': json['transshipment'] == null ? undefined : json['transshipment'],
        'warehouseFunction': json['warehouseFunction'] == null ? undefined : json['warehouseFunction'],
        'dropshippingFee': json['dropshippingFee'] == null ? undefined : json['dropshippingFee'],
        'freeStorageDays': json['freeStorageDays'] == null ? undefined : json['freeStorageDays'],
        'rocketOrderFreeStorageDays': json['rocketOrderFreeStorageDays'] == null ? undefined : json['rocketOrderFreeStorageDays'],
        'storageFeeUnit': json['storageFeeUnit'] == null ? undefined : json['storageFeeUnit'],
        'boxUnloadingFeeUnit': json['boxUnloadingFeeUnit'] == null ? undefined : json['boxUnloadingFeeUnit'],
        'palletUnloadingFeeUnit': json['palletUnloadingFeeUnit'] == null ? undefined : json['palletUnloadingFeeUnit'],
        'transportMethodIds': json['transportMethodIds'] == null ? undefined : json['transportMethodIds'],
    };
}

export function WarehouseAddReqVoToJSON(json: any): WarehouseAddReqVo {
    return WarehouseAddReqVoToJSONTyped(json, false);
}

export function WarehouseAddReqVoToJSONTyped(value?: WarehouseAddReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warehouseType': value['warehouseType'],
        'name': value['name'],
        'nameCn': value['nameCn'],
        'nationId': value['nationId'],
        'code': value['code'],
        'warehouseProxyCode': value['warehouseProxyCode'],
        'boxMarknoPrefix': value['boxMarknoPrefix'],
        'palletMarknoPrefix': value['palletMarknoPrefix'],
        'zip': value['zip'],
        'connectWarehouseId': value['connectWarehouseId'],
        'city': value['city'],
        'state': value['state'],
        'address': value['address'],
        'addressDetail': value['addressDetail'],
        'addressEn': value['addressEn'],
        'addressDetailEn': value['addressDetailEn'],
        'mobileNo': value['mobileNo'],
        'contactName': value['contactName'],
        'enable': value['enable'],
        'receivingMethod': value['receivingMethod'],
        'transshipment': value['transshipment'],
        'warehouseFunction': value['warehouseFunction'],
        'dropshippingFee': value['dropshippingFee'],
        'freeStorageDays': value['freeStorageDays'],
        'rocketOrderFreeStorageDays': value['rocketOrderFreeStorageDays'],
        'storageFeeUnit': value['storageFeeUnit'],
        'boxUnloadingFeeUnit': value['boxUnloadingFeeUnit'],
        'palletUnloadingFeeUnit': value['palletUnloadingFeeUnit'],
        'transportMethodIds': value['transportMethodIds'],
    };
}

